import {DynamicFieldDefinition} from "../types";
import {Input} from "@/components/ui/input";
import {Textarea} from "@/components/ui/textarea.tsx";
import {Checkbox} from "@/components/ui/checkbox";
import {Label} from "@/components/ui/label";

interface DynamicFieldsFormSectionProps {
    fields: DynamicFieldDefinition[];
    values: Record<string, string | boolean>;
    onChange: (fieldName: string, value: string | boolean) => void;
    disabled?: boolean;
}

// רינדור גנרי לשדות דינמיים (DynamicField) לפי field_format — לשימוש חוזר בכל טופס יצירת/עריכת משתמש.
export function DynamicFieldsFormSection({fields, values, onChange, disabled}: DynamicFieldsFormSectionProps) {
    if (!fields.length) {
        return null;
    }

    return (
        <div className="space-y-4 border-t border-gray-200 pt-4">
            <div className="text-base font-medium text-muted-foreground">שדות נוספים</div>
            {fields.map((field) => (
                <div key={field.id} className="space-y-2">
                    {field.field_format === 'checkbox' ? (
                        <div className="flex items-center gap-2">
                            <Checkbox
                                checked={Boolean(values[field.field_name] ?? false)}
                                onCheckedChange={(checked) => onChange(field.field_name, Boolean(checked))}
                                disabled={disabled}
                            />
                            <Label className="text-base font-medium">{field.description || field.field_name}</Label>
                        </div>
                    ) : (
                        <>
                            <Label className="text-base font-medium">{field.description || field.field_name}</Label>
                            {field.field_format === 'textarea' ? (
                                <Textarea
                                    value={String(values[field.field_name] ?? '')}
                                    onChange={(e) => onChange(field.field_name, e.target.value)}
                                    disabled={disabled}
                                    className="text-base"
                                />
                            ) : (
                                <Input
                                    type={
                                        field.field_format === 'date' ? 'date'
                                            : field.field_format === 'time' ? 'time'
                                            : (field.field_format === 'integer' || field.field_format === 'number') ? 'number'
                                            : 'text'
                                    }
                                    value={String(values[field.field_name] ?? '')}
                                    onChange={(e) => onChange(field.field_name, e.target.value)}
                                    disabled={disabled}
                                    className="text-base h-11"
                                />
                            )}
                        </>
                    )}
                </div>
            ))}
        </div>
    );
}
